const urlRegex = /(https?:\/\/[^\s]+)/g;

export const parseMessage = (text: string) => {
  return text.split(urlRegex).map((part, i) => {
    if (urlRegex.test(part)) {
      return (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#1976d2", textDecoration: "underline" }} // optional MUI style
        >
          {part}
        </a>
      );
    }
    return part;
  });
};
